function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "horror movie");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M918,157.87V583.13A105.34,105.34,0,0,1,812.63,688.5H387.37a105,105,0,0,1-65.55-22.86,106.41,106.41,0,0,1-20.26-21.34A105.38,105.38,0,0,1,282,583.13V157.87q0-4.23.33-8.37a104,104,0,0,1,2.51-16,105.4,105.4,0,0,1,102.53-81H812.63a105.4,105.4,0,0,1,102.53,81,104,104,0,0,1,2.51,16Q918,153.64,918,157.87Z",
  transform: "translate(-89 -52.5)",
  fill: "#e83f5b",
  opacity: 0.1
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M608,387.5H918v16H608v111H918v16H608v158H592v-158H282v-16H592v-111H282v-16H592v-111H282v-16H592v-111H282.33a104,104,0,0,1,2.51-16H592v-81h16v81H915.16a104,104,0,0,1,2.51,16H608v111H918v16H608Z",
  transform: "translate(-89 -52.5)",
  fill: "#e83f5b",
  opacity: 0.1
});

var _ref5 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 511,
  cy: 714.83,
  rx: 511,
  ry: 80.17,
  fill: "#e83f5b",
  opacity: 0.1
});

var _ref6 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 902.7,
  cy: 681.14,
  rx: 25.3,
  ry: 4.87,
  fill: "#e83f5b"
});

var _ref7 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 902.28,
  cy: 679.08,
  rx: 2.95,
  ry: 3.86,
  fill: "#3f3d56"
});

var _ref8 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 902.28,
  cy: 674.36,
  rx: 2.95,
  ry: 3.86,
  fill: "#3f3d56"
});

var _ref9 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 902.28,
  cy: 669.65,
  rx: 2.95,
  ry: 3.86,
  fill: "#3f3d56"
});

var _ref10 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 902.28,
  cy: 664.94,
  rx: 2.95,
  ry: 3.86,
  fill: "#3f3d56"
});

var _ref11 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 902.28,
  cy: 660.22,
  rx: 2.95,
  ry: 3.86,
  fill: "#3f3d56"
});

var _ref12 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 902.28,
  cy: 655.51,
  rx: 2.95,
  ry: 3.86,
  fill: "#3f3d56"
});

var _ref13 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 902.28,
  cy: 650.8,
  rx: 2.95,
  ry: 3.86,
  fill: "#3f3d56"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M1002.3,671.05a13.58,13.58,0,0,0,1.1-1.62l-7.74-1.27,8.37.06a14.16,14.16,0,0,0,.27-11.18l-11.23,5.83,10.36-7.62a14.12,14.12,0,1,0-23.31,15.8,14.43,14.43,0,0,0-1.61,2.57l10,5.22-10.71-3.6a14.09,14.09,0,0,0,2.27,13.25,14.11,14.11,0,1,0,22.18,0,14.1,14.1,0,0,0,0-17.44Z",
  transform: "translate(-89 -52.5)",
  fill: "#e83f5b"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M977.1,679.77a14.05,14.05,0,0,0,3,8.72,14.11,14.11,0,1,0,22.18,0C1004.19,686.09,977.1,678.19,977.1,679.77Z",
  transform: "translate(-89 -52.5)",
  opacity: 0.1
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  x: 206.5,
  y: 557,
  width: 603,
  height: 138.5,
  fill: "#46455b"
});

var _ref17 = /*#__PURE__*/React.createElement("polygon", {
  points: "210.5 413.5 153.5 456.5 197.5 496.5 222.5 456.5 256.5 413.5 210.5 413.5",
  fill: "#46455b"
});

var _ref18 = /*#__PURE__*/React.createElement("polygon", {
  points: "799.5 465.5 791.5 456.5 740.5 427.5 787.5 426.5 860.5 456.5 830.5 475.5 799.5 465.5",
  fill: "#46455b"
});

var _ref19 = /*#__PURE__*/React.createElement("polygon", {
  points: "206.5 467.5 256.5 413.5 256.5 537.5 222.5 565.5 201.5 536.5 206.5 467.5",
  fill: "#46455b"
});

var _ref20 = /*#__PURE__*/React.createElement("polygon", {
  points: "800.5 489.5 791.5 456.5 774.5 434.5 740.5 427.5 740.5 565.5 809.5 565.5 800.5 489.5",
  fill: "#46455b"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M267.55,376.5h466.9A15.55,15.55,0,0,1,750,392.05V534.5a0,0,0,0,1,0,0H252a0,0,0,0,1,0,0V392.05A15.55,15.55,0,0,1,267.55,376.5Z",
  fill: "#46455b"
});

var _ref22 = /*#__PURE__*/React.createElement("polygon", {
  points: "222.5 565.5 256.5 523.5 740.5 523.5 791.5 565.5 222.5 565.5",
  fill: "#46455b"
});

var _ref23 = /*#__PURE__*/React.createElement("polygon", {
  points: "222.5 565.5 256.5 523.5 740.5 523.5 791.5 565.5 222.5 565.5",
  opacity: 0.05
});

var _ref24 = /*#__PURE__*/React.createElement("rect", {
  x: 153.5,
  y: 456.5,
  width: 69,
  height: 239,
  fill: "#46455b"
});

var _ref25 = /*#__PURE__*/React.createElement("rect", {
  x: 153.5,
  y: 456.5,
  width: 69,
  height: 239,
  fill: "#fff",
  opacity: 0.05
});

var _ref26 = /*#__PURE__*/React.createElement("rect", {
  x: 791.5,
  y: 456.5,
  width: 69,
  height: 239,
  fill: "#46455b"
});

var _ref27 = /*#__PURE__*/React.createElement("rect", {
  x: 791.5,
  y: 456.5,
  width: 69,
  height: 239,
  fill: "#fff",
  opacity: 0.05
});

var _ref28 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 440,
  cy: 306.5,
  rx: 80,
  ry: 105.5,
  fill: "#2f2e41"
});

var _ref29 = /*#__PURE__*/React.createElement("rect", {
  x: 386,
  y: 261,
  width: 89,
  height: 124,
  fill: "#2f2e41"
});

var _ref30 = /*#__PURE__*/React.createElement("rect", {
  x: 386,
  y: 261,
  width: 89,
  height: 124,
  opacity: 0.1
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M481.46,386.22a26.08,26.08,0,0,1-23.3,9.34c-.4,6.22,3.82,11.68,7.81,16.47L497.2,449.5a1.75,1.75,0,0,0,3.1.26L548,404.51c-4.76,2-10.39-1.17-13-5.63s-2.87-9.82-3.11-15q-.52-11.6-1-23.18c-.08-1.72-.25-3.62-1.52-4.78a6.52,6.52,0,0,0-3.4-1.29c-7.53-1.29-31-8-35.35-.08-2,3.61-1.1,10.65-2,14.73C487.27,375.33,485.36,381.36,481.46,386.22Z",
  transform: "translate(-89 -52.5)",
  fill: "#fbbebe"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M481.46,386.22a26.08,26.08,0,0,1-23.3,9.34c-.4,6.22,3.82,11.68,7.81,16.47L497.2,449.5a1.75,1.75,0,0,0,3.1.26L548,404.51c-4.76,2-10.39-1.17-13-5.63s-2.87-9.82-3.11-15q-.52-11.6-1-23.18c-.08-1.72-.25-3.62-1.52-4.78a6.52,6.52,0,0,0-3.4-1.29c-7.53-1.29-31-8-35.35-.08-2,3.61-1.1,10.65-2,14.73C487.27,375.33,485.36,381.36,481.46,386.22Z",
  transform: "translate(-89 -52.5)",
  opacity: 0.1
});

var _ref33 = /*#__PURE__*/React.createElement("circle", {
  cx: 427,
  cy: 279,
  r: 47,
  fill: "#fbbebe"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M499,426.14l-7.54-23.77c-3-9.52-7.26-20.31-16.76-23.38-6-1.92-12.47-.16-18.72-.69-12.16-1.05-24-10.72-35.37-6.29-14,5.44-13.88,26.94-26.31,35.38,0,20.09,6.49,38.75,10,58.52s4.52,41.11-4.64,59c-3.88,7.58-9.43,14.18-13.57,21.62a67.15,67.15,0,0,0-7.94,40.28q79.62,1,159.26.48c-.49-6.88-3.56-13.66-4.06-20.54a14.21,14.21,0,0,1,.48-6.2c1.17-3,4.15-4.79,6.7-6.74a34.55,34.55,0,0,0,8.53-9.58c3.54-5.89,5.22-12.68,6.86-19.36l19.88-81c2.37-9.65,4.67-20.18.55-29.22-4.52-9.93-15.36-15.09-25.37-19.44-6-2.63-12.9-5.29-19-2.87-5,2-8.14,6.79-11.3,11.13A110.66,110.66,0,0,1,499,426.14Z",
  transform: "translate(-89 -52.5)",
  fill: "#f86d70"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M393.77,414.52c-1.56,5.84-.69,12.08-1.84,18-1.93,9.91-9.16,17.79-14,26.63a60.57,60.57,0,0,0-5.3,44.92c1.22,4.41,3.39,9.13,7.67,10.75,3.06,1.17,6.48.44,9.75.73,4.32.38,8.81,2.52,12.8.82,4.93-2.1,5.91-8.51,6.45-13.84a162.14,162.14,0,0,1,7.93-36.29c4-11.76,9.49-23.43,9.41-35.86-.06-8.76-11.28-.7-18.6-5.89C399.78,418.67,396.48,404.43,393.77,414.52Z",
  transform: "translate(-89 -52.5)",
  opacity: 0.1
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M391.77,413.52c-1.56,5.84-.69,12.08-1.84,18-1.93,9.91-9.16,17.79-14,26.63a60.57,60.57,0,0,0-5.3,44.92c1.22,4.41,3.39,9.13,7.67,10.75,3.06,1.17,6.48.44,9.75.73,4.32.38,8.81,2.52,12.8.82,4.93-2.1,5.91-8.51,6.45-13.84a162.14,162.14,0,0,1,7.93-36.29c4-11.76,9.49-23.43,9.41-35.86-.06-8.76-3.91-18.44-11.23-23.63C405.15,399.93,394.48,403.43,391.77,413.52Z",
  transform: "translate(-89 -52.5)",
  fill: "#f86d70"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M460.2,358.53c6-3.36,11.91-7,18.09-10.12,9.66-4.83,20.52-8.6,28.12-16a3.17,3.17,0,0,1,5.22,1.37,295.43,295.43,0,0,0,11.59,31.32c3.84,8.8,8.12,17.44,11,26.6,2,6.37,3.25,13,5.74,19.13,3.25,8,8.44,15.12,13.59,22.1,1.89,2.58,3.84,5.2,6.49,7,3.72,2.53,9.27,4.15,9.66,8.63-4.83,3.49-11.4,2.34-17.35,2.29s-12,1.18-17.88,2.63a107.71,107.71,0,0,0-20,6.68c-6.26,2.95-12,6.83-17.8,10.69l-53.17,35.67c-3.91-4.47-3.76-11-4.6-16.92a88,88,0,0,0-3.08-12.57l-5.3-17.85c-2.52-8.48-5-16.95-7.84-25.34-2.34-7-4.94-14.07-9.52-19.85-5.52-7-13.46-11.54-20.35-17.17-2.44-2-4.85-4.28-5.76-7.3a7.14,7.14,0,0,1,.8-5.92c1.46-2.11,3.55-1.8,5.87-2.17q8.49-1.35,16.84-3.41a204,204,0,0,0,32.27-10.94Q451.72,363.24,460.2,358.53Z",
  transform: "translate(-89 -52.5)",
  fill: "#bbbdc8"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M462.38,365.93c5.27-2.92,10.39-6.12,15.78-8.82,8.44-4.22,17.9-7.5,24.53-13.93a2.76,2.76,0,0,1,4.56,1.19,257,257,0,0,0,10.11,27.32c3.35,7.68,7.08,15.22,9.57,23.21,1.72,5.55,2.83,11.3,5,16.69,2.83,7,7.37,13.19,11.85,19.28a24.77,24.77,0,0,0,5.66,6.1c3.26,2.21,8.1,3.62,8.43,7.54-4.21,3-9.94,2-15.13,2a62.53,62.53,0,0,0-15.59,2.3,93.19,93.19,0,0,0-17.43,5.83A119.35,119.35,0,0,0,494.19,464L447.8,495.07c-3.41-3.9-3.27-9.63-4-14.77a76.83,76.83,0,0,0-2.68-11l-4.63-15.57c-2.2-7.4-4.4-14.79-6.84-22.11-2-6.11-4.3-12.27-8.3-17.32-4.82-6.09-11.74-10.06-17.76-15-2.12-1.73-4.23-3.73-5-6.36a6.21,6.21,0,0,1,.7-5.16c1.27-1.85,3.1-1.58,5.12-1.9q7.41-1.17,14.69-3a176.68,176.68,0,0,0,28.15-9.54Q455,370,462.38,365.93Z",
  transform: "translate(-89 -52.5)",
  opacity: 0.1
});

var _ref39 = /*#__PURE__*/React.createElement("circle", {
  cx: 353.97,
  cy: 350.14,
  r: 4,
  fill: "#bbbdc8"
});

var _ref40 = /*#__PURE__*/React.createElement("circle", {
  cx: 396.62,
  cy: 330.39,
  r: 4,
  fill: "#bbbdc8"
});

var _ref41 = /*#__PURE__*/React.createElement("circle", {
  cx: 374.14,
  cy: 393.7,
  r: 4,
  fill: "#bbbdc8"
});

var _ref42 = /*#__PURE__*/React.createElement("circle", {
  cx: 416.79,
  cy: 373.95,
  r: 4,
  fill: "#bbbdc8"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M401.29,471.34c4-1.15,8.21-2.41,11.15-5.36,2.28-2.3,3.55-5.39,5.15-8.21,3.19-5.63,8.24-10.62,14.59-11.86s13.81,2.43,15.17,8.76c.88,4.12-.84,8.31-2.55,12.17-2.56,5.78-5.45,11.84-10.73,15.33-4.62,3.05-10.51,3.72-15.05,6.89-4,2.8-6.52,7.23-10,10.68a26.43,26.43,0,0,1-16.94,7.55,5.73,5.73,0,0,1-2.85-.39,6.29,6.29,0,0,1-2.16-2.13c-2.94-4-5.92-8.12-7.48-12.85C374.16,475.43,389.53,474.71,401.29,471.34Z",
  transform: "translate(-89 -52.5)",
  fill: "#fbbebe"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M507.83,473.54c-1.35-8.06-1.53-16.85-6.51-23.33-4.17-5.41-11.1-8.15-17.92-8.61-2-.14-4.35.06-5.51,1.7a6.1,6.1,0,0,0-.75,3.82A46.13,46.13,0,0,0,488,475c2.49,2.92,5.38,5.58,7.12,9,1.52,2.95,2.08,6.32,3.49,9.32,1.84,3.91,5,7,7.42,10.6a30.49,30.49,0,0,1,5.1,17.43c2.64-4.31,2.32-9.7,2.57-14.75.33-7.11,5.31-11,2.08-16.8S509,480.59,507.83,473.54Z",
  transform: "translate(-89 -52.5)",
  fill: "#fbbebe"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M544.74,465.51c-2.53,6.6-3.83,13.66-6.81,20.07a11.2,11.2,0,0,1-3.88,5c-3.2,2-7.43.76-10.61-1.23s-6-4.73-9.47-6.05c-1.56,15.19-14.18,28.56-29.26,31,9,8.27,18.48,17.46,20.51,29.5.38,2.21.51,4.56,1.69,6.47,1.9,3.05,5.91,4.05,9.51,4,9.15-.07,17.54-4.9,25.18-10,2.58-1.7,5.19-3.52,6.91-6.08s2.46-5.81,3.11-8.91q6.63-31.51,13.25-63.05c1.2-5.71,1-16.93-7.86-15.8C551,451.31,546.6,460.68,544.74,465.51Z",
  transform: "translate(-89 -52.5)",
  opacity: 0.1
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M546.74,465.51c-2.53,6.6-3.83,13.66-6.81,20.07a11.2,11.2,0,0,1-3.88,5c-3.2,2-7.43.76-10.61-1.23s-6-4.73-9.47-6.05c-1.56,15.19-14.18,28.56-29.26,31,9,8.27,18.48,17.46,20.51,29.5.38,2.21.51,4.56,1.69,6.47,1.9,3.05,5.91,4.05,9.51,4,9.15-.07,17.54-4.9,25.18-10,2.58-1.7,5.19-3.52,6.91-6.08s2.46-5.81,3.11-8.91q6.63-31.51,13.25-63.05c1.2-5.71,1-16.93-7.86-15.8C553,451.31,548.6,460.68,546.74,465.51Z",
  transform: "translate(-89 -52.5)",
  fill: "#f86d70"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M400.86,504.51c-.36,1.83-2.17,2.94-3.81,3.82-3.17,1.71-6.62,3.48-10.19,3s-6.56-3.12-8.9-5.92a22.82,22.82,0,0,1-3-4.36c-3.61-7.13-4-37.47,10.92-27.57,6.16,4.1,2.69,11.1,3.46,17.13a17.52,17.52,0,0,0,4.09,9.7C393.88,500.83,400.63,505.69,400.86,504.51Z",
  transform: "translate(-89 -52.5)",
  fill: "#f86d70"
});

var _ref48 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 439.5,
  cy: 247,
  rx: 44.5,
  ry: 21,
  fill: "#2f2e41"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M530.5,313.5c-24.08,0-43.67-9-44.46-20.3a11.34,11.34,0,0,0-2,6.3c0,11.6,19.92,21,44.5,21s44.5-9.4,44.5-21c0-.24,0-.47,0-.7C567.29,307.32,550.43,313.5,530.5,313.5Z",
  transform: "translate(-89 -52.5)",
  opacity: 0.1
});

var _ref50 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 635,
  cy: 310,
  rx: 110,
  ry: 100,
  fill: "#2f2e41"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M724,436.5c-55.71,0-101.75-37.66-109-86.5a92.66,92.66,0,0,0-1,13.5c0,55.23,49.25,100,110,100s110-44.77,110-100a92.66,92.66,0,0,0-1-13.5C825.75,398.84,779.71,436.5,724,436.5Z",
  transform: "translate(-89 -52.5)",
  opacity: 0.1
});

var _ref52 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 633,
  cy: 313.5,
  rx: 53,
  ry: 71.5,
  fill: "#2f2e41"
});

var _ref53 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 633,
  cy: 313.5,
  rx: 53,
  ry: 71.5,
  opacity: 0.1
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M697.63,402.24c-2,4.94-6,10.19-12,10.57,8,6.57,16.1,13.21,25.66,18s20.88,7.6,31.76,5.88c7.68-1.21,14.66-4.58,21.18-8.27,11.1-6.28,22-14.53,24.81-25.71a181.38,181.38,0,0,1-25-.47c-4.31-.37-8.72-.94-12.46-2.82a19.43,19.43,0,0,1-9.57-11.7c-1.49-4.72-1.46-9.69-1.19-14.58.15-2.85.26-6-1.93-8.18s-5.81-2.47-9.1-2.54A125.05,125.05,0,0,0,710,363.59a68,68,0,0,0-10.19,1.85c-4.34,1.32-3.93.81-2.88,4.44C700.19,381,702.18,391,697.63,402.24Z",
  transform: "translate(-89 -52.5)",
  fill: "#a0616a"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M697.63,402.24c-2,4.94-6,10.19-12,10.57,8,6.57,16.1,13.21,25.66,18s20.88,7.6,31.76,5.88c7.68-1.21,14.66-4.58,21.18-8.27,11.1-6.28,22-14.53,24.81-25.71a181.38,181.38,0,0,1-25-.47c-4.31-.37-8.72-.94-12.46-2.82a19.43,19.43,0,0,1-9.57-11.7c-1.49-4.72-1.46-9.69-1.19-14.58.15-2.85.26-6-1.93-8.18s-5.81-2.47-9.1-2.54A125.05,125.05,0,0,0,710,363.59a68,68,0,0,0-10.19,1.85c-4.34,1.32-3.93.81-2.88,4.44C700.19,381,702.18,391,697.63,402.24Z",
  transform: "translate(-89 -52.5)",
  opacity: 0.1
});

var _ref56 = /*#__PURE__*/React.createElement("circle", {
  cx: 631.5,
  cy: 292.5,
  r: 47,
  fill: "#a0616a"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M704.3,406.38c-3.07-3.68-6.23-7.44-10.32-9.94-6.7-4.11-15-4.37-22.85-4.5-8.51-.15-17.76-.07-24.49,5.14-3,2.35-5.3,5.57-7.49,8.73l-28.51,41c-1.11,1.6-2.28,3.41-2,5.34a7.84,7.84,0,0,0,2,3.69L642,495c1.79,2.23,3.64,4.58,4.24,7.38s-.14,5.74-1.1,8.46c-3.79,10.79-11,21-10.34,32.37.47,7.42,4.35,14.24,9.1,20,10.9,13.13,26.59,21.67,43,26.33s33.64,5.68,50.71,5.79c32.18.21,66-3.3,92.58-21.45l-20.89-19.68c-4.13-3.9-8.46-8.1-9.89-13.6-1-3.7-.52-7.6-.07-11.39.84-6.93,1.68-13.91,3.92-20.51,6.23-18.39,22.24-31.48,32.92-47.69,1.34-2,2.64-4.3,2.49-6.73-.12-2.05-1.26-3.88-2.37-5.6-4.88-7.57-9.94-15.1-13.48-23.38-2.64-6.16-4.43-12.71-7.7-18.56s-8.46-11.11-15-12.34c-8.42-1.58-16.63,3.69-25.18,4.05-6.26.27-12.79-2.08-18.64.15-6.94,2.65-10,10.47-13.89,16.82-2.87,4.73-11.43,17.67-18.14,14.49-3.65-1.74-7-8-9.62-11.07Z",
  transform: "translate(-89 -52.5)",
  fill: "#f98a8d"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M741.74,438.17a8.06,8.06,0,0,0-5.22-.94,4.09,4.09,0,0,0-3.31,3.74l-2.89-.17a3.23,3.23,0,0,0-1,.05A1.59,1.59,0,0,0,730,444a9.64,9.64,0,0,0-3.69,2.6,5.17,5.17,0,0,0,1.4,7.14,5.6,5.6,0,0,0,7.26-1.48,2.63,2.63,0,0,0,1.4,3.09c5.42,2.93,8.18-1.05,8.92-5.66C746.13,444.63,747.21,440.87,741.74,438.17Z",
  transform: "translate(-89 -52.5)",
  fill: "#ffe9b3"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M741.74,438.17a8.06,8.06,0,0,0-5.22-.94,4.09,4.09,0,0,0-3.31,3.74l-2.89-.17a3.23,3.23,0,0,0-1,.05A1.59,1.59,0,0,0,730,444a9.64,9.64,0,0,0-3.69,2.6,5.17,5.17,0,0,0,1.4,7.14,5.6,5.6,0,0,0,7.26-1.48,2.63,2.63,0,0,0,1.4,3.09c5.42,2.93,8.18-1.05,8.92-5.66C746.13,444.63,747.21,440.87,741.74,438.17Z",
  transform: "translate(-89 -52.5)",
  opacity: 0.15
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M756.5,434.77a8,8,0,0,0-5.22-.93,4.06,4.06,0,0,0-3.3,3.73l-2.89-.17a3.3,3.3,0,0,0-1,.05,1.66,1.66,0,0,0-1.13,1.91,1.64,1.64,0,0,0,1.87,1.19,9.71,9.71,0,0,0-3.69,2.6,5.18,5.18,0,0,0,1.4,7.14,5.61,5.61,0,0,0,7.27-1.47,2.62,2.62,0,0,0,1.39,3.08c5.43,2.94,8.18-1,8.93-5.65C760.9,441.23,762,437.47,756.5,434.77Z",
  transform: "translate(-89 -52.5)",
  fill: "#ffe9b3"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M768.54,436.49a8,8,0,0,0-5.21-.93,4.06,4.06,0,0,0-3.31,3.73l-2.89-.17a3.22,3.22,0,0,0-1,.05,1.66,1.66,0,0,0-1.13,1.91,1.64,1.64,0,0,0,1.87,1.19,9.56,9.56,0,0,0-3.69,2.6,5.17,5.17,0,0,0,1.4,7.14,5.59,5.59,0,0,0,7.26-1.47,2.62,2.62,0,0,0,1.4,3.08c5.42,2.94,8.17-1.05,8.92-5.65C772.94,443,774,439.19,768.54,436.49Z",
  transform: "translate(-89 -52.5)",
  fill: "#ffe9b3"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M768.54,436.49a8,8,0,0,0-5.21-.93,4.06,4.06,0,0,0-3.31,3.73l-2.89-.17a3.22,3.22,0,0,0-1,.05,1.66,1.66,0,0,0-1.13,1.91,1.64,1.64,0,0,0,1.87,1.19,9.56,9.56,0,0,0-3.69,2.6,5.17,5.17,0,0,0,1.4,7.14,5.59,5.59,0,0,0,7.26-1.47,2.62,2.62,0,0,0,1.4,3.08c5.42,2.94,8.17-1.05,8.92-5.65C772.94,443,774,439.19,768.54,436.49Z",
  transform: "translate(-89 -52.5)",
  opacity: 0.15
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  d: "M798,443.5V550.92a2.59,2.59,0,0,1-2.58,2.58H711.58a2.59,2.59,0,0,1-2.58-2.58V443.5a2.58,2.58,0,0,1,3.61-2.37q3.2,1.38,6.39,2.55,4.5,1.65,9,2.87c3,.81,6,1.48,9,2s6,.92,9,1.16,6,.34,9,.28,6-.23,9-.56,6-.82,9-1.45,6-1.37,9-2.28c2.33-.71,4.67-1.5,7-2.38,1.8-.67,3.59-1.4,5.39-2.18A2.58,2.58,0,0,1,798,443.5Z",
  transform: "translate(-89 -52.5)",
  fill: "#bbbdc8"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  d: "M728,446.55v107h-9V443.68Q723.5,445.33,728,446.55Z",
  transform: "translate(-89 -52.5)",
  fill: "#fff"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  d: "M746,449.7V553.5h-9v-105C740,449.08,743,449.46,746,449.7Z",
  transform: "translate(-89 -52.5)",
  fill: "#fff"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  d: "M764,449.42V553.5h-9V450Q759.5,449.92,764,449.42Z",
  transform: "translate(-89 -52.5)",
  fill: "#fff"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  d: "M782,445.69V553.5h-9V448Q777.5,447.06,782,445.69Z",
  transform: "translate(-89 -52.5)",
  fill: "#fff"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  d: "M798,443.5V550.92a2.59,2.59,0,0,1-2.58,2.58H789V443.31c1.8-.67,3.59-1.4,5.39-2.18A2.58,2.58,0,0,1,798,443.5Z",
  transform: "translate(-89 -52.5)",
  opacity: 0.1
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  d: "M732.41,433.05a8,8,0,0,0-5.21-.93,4.06,4.06,0,0,0-3.31,3.73l-2.89-.17a3.22,3.22,0,0,0-1,.05,1.66,1.66,0,0,0-1.13,1.91,1.64,1.64,0,0,0,1.87,1.19,9.56,9.56,0,0,0-3.69,2.6,5.17,5.17,0,0,0,1.4,7.14,5.6,5.6,0,0,0,7.26-1.47,2.62,2.62,0,0,0,1.4,3.08c5.42,2.93,8.17-1.05,8.92-5.65C736.81,439.51,737.89,435.75,732.41,433.05Z",
  transform: "translate(-89 -52.5)",
  fill: "#ffe9b3"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  d: "M747.41,416.05a8,8,0,0,0-5.21-.93,4.06,4.06,0,0,0-3.31,3.73l-2.89-.17a3.22,3.22,0,0,0-1,.05,1.66,1.66,0,0,0-1.13,1.91,1.64,1.64,0,0,0,1.87,1.19,9.56,9.56,0,0,0-3.69,2.6,5.17,5.17,0,0,0,1.4,7.14,5.6,5.6,0,0,0,7.26-1.47,2.62,2.62,0,0,0,1.4,3.08c5.42,2.93,8.17-1.05,8.92-5.65C751.81,422.51,752.89,418.75,747.41,416.05Z",
  transform: "translate(-89 -52.5)",
  fill: "#ffe9b3"
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  d: "M757.6,439.14a8,8,0,0,0,1.93-4.94,4.06,4.06,0,0,0-3-4l.73-2.8a3,3,0,0,0,.15-1,1.59,1.59,0,0,0-3.18.12,9.57,9.57,0,0,0-1.83-4.12,5.18,5.18,0,0,0-7.28,0,5.6,5.6,0,0,0,0,7.41,2.63,2.63,0,0,0-3.3.78c-3.93,4.74-.56,8.22,3.81,9.85C750.41,442.2,753.89,444,757.6,439.14Z",
  transform: "translate(-89 -52.5)",
  fill: "#ffe9b3"
});

var _ref72 = /*#__PURE__*/React.createElement("path", {
  d: "M770.6,439.14a8,8,0,0,0,1.93-4.94,4.06,4.06,0,0,0-3-4l.73-2.8a3,3,0,0,0,.15-1,1.59,1.59,0,0,0-3.18.12,9.57,9.57,0,0,0-1.83-4.12,5.18,5.18,0,0,0-7.28,0,5.6,5.6,0,0,0,0,7.41,2.63,2.63,0,0,0-3.3.78c-3.93,4.74-.56,8.22,3.81,9.85C763.41,442.2,766.89,444,770.6,439.14Z",
  transform: "translate(-89 -52.5)",
  fill: "#ffe9b3"
});

var _ref73 = /*#__PURE__*/React.createElement("path", {
  d: "M778.74,447.69a8,8,0,0,0,1-5.21,4.07,4.07,0,0,0-3.7-3.35l.21-2.88a3.3,3.3,0,0,0,0-1,1.59,1.59,0,0,0-3.1.71,9.73,9.73,0,0,0-2.56-3.72,5.18,5.18,0,0,0-7.16,1.32,5.6,5.6,0,0,0,1.4,7.28,2.63,2.63,0,0,0-3.1,1.37c-3,5.39,1,8.19,5.56,9C772.24,452,776,453.13,778.74,447.69Z",
  transform: "translate(-89 -52.5)",
  fill: "#ffe9b3"
});

var _ref74 = /*#__PURE__*/React.createElement("path", {
  d: "M738.74,431.69a8,8,0,0,0,1-5.21,4.07,4.07,0,0,0-3.7-3.35l.21-2.88a3.3,3.3,0,0,0,0-1,1.59,1.59,0,0,0-3.1.71,9.73,9.73,0,0,0-2.56-3.72,5.18,5.18,0,0,0-7.16,1.32,5.6,5.6,0,0,0,1.4,7.28,2.63,2.63,0,0,0-3.1,1.37c-3,5.39,1,8.19,5.56,9C732.24,436,736,437.13,738.74,431.69Z",
  transform: "translate(-89 -52.5)",
  fill: "#ffe9b3"
});

var _ref75 = /*#__PURE__*/React.createElement("path", {
  d: "M742.74,426.17a8.06,8.06,0,0,0-5.22-.94,4.09,4.09,0,0,0-3.31,3.74l-2.89-.17a3.23,3.23,0,0,0-1,.05A1.59,1.59,0,0,0,731,432a9.64,9.64,0,0,0-3.69,2.6,5.17,5.17,0,0,0,1.4,7.14,5.6,5.6,0,0,0,7.26-1.48,2.63,2.63,0,0,0,1.4,3.09c5.42,2.93,8.18-1.05,8.92-5.66C747.13,432.63,748.21,428.87,742.74,426.17Z",
  transform: "translate(-89 -52.5)",
  fill: "#ffe9b3"
});

var _ref76 = /*#__PURE__*/React.createElement("path", {
  d: "M742.74,426.17a8.06,8.06,0,0,0-5.22-.94,4.09,4.09,0,0,0-3.31,3.74l-2.89-.17a3.23,3.23,0,0,0-1,.05A1.59,1.59,0,0,0,731,432a9.64,9.64,0,0,0-3.69,2.6,5.17,5.17,0,0,0,1.4,7.14,5.6,5.6,0,0,0,7.26-1.48,2.63,2.63,0,0,0,1.4,3.09c5.42,2.93,8.18-1.05,8.92-5.66C747.13,432.63,748.21,428.87,742.74,426.17Z",
  transform: "translate(-89 -52.5)",
  opacity: 0.15
});

var _ref77 = /*#__PURE__*/React.createElement("path", {
  d: "M785.75,429.61a8,8,0,0,0-5.22-.93,4.07,4.07,0,0,0-3.31,3.73l-2.88-.17a3.28,3.28,0,0,0-1,.05,1.66,1.66,0,0,0-1.13,1.91,1.64,1.64,0,0,0,1.87,1.19,9.71,9.71,0,0,0-3.69,2.6,5.18,5.18,0,0,0,1.4,7.14,5.6,5.6,0,0,0,7.26-1.47,2.62,2.62,0,0,0,1.4,3.08c5.42,2.93,8.18-1.05,8.92-5.66C790.14,436.07,791.22,432.31,785.75,429.61Z",
  transform: "translate(-89 -52.5)",
  fill: "#ffe9b3"
});

var _ref78 = /*#__PURE__*/React.createElement("path", {
  d: "M785.75,429.61a8,8,0,0,0-5.22-.93,4.07,4.07,0,0,0-3.31,3.73l-2.88-.17a3.28,3.28,0,0,0-1,.05,1.66,1.66,0,0,0-1.13,1.91,1.64,1.64,0,0,0,1.87,1.19,9.71,9.71,0,0,0-3.69,2.6,5.18,5.18,0,0,0,1.4,7.14,5.6,5.6,0,0,0,7.26-1.47,2.62,2.62,0,0,0,1.4,3.08c5.42,2.93,8.18-1.05,8.92-5.66C790.14,436.07,791.22,432.31,785.75,429.61Z",
  transform: "translate(-89 -52.5)",
  opacity: 0.15
});

var _ref79 = /*#__PURE__*/React.createElement("path", {
  d: "M759.75,412.61a8,8,0,0,0-5.22-.93,4.07,4.07,0,0,0-3.31,3.73l-2.88-.17a3.28,3.28,0,0,0-1,.05,1.66,1.66,0,0,0-1.13,1.91,1.64,1.64,0,0,0,1.87,1.19,9.71,9.71,0,0,0-3.69,2.6,5.18,5.18,0,0,0,1.4,7.14,5.6,5.6,0,0,0,7.26-1.47,2.62,2.62,0,0,0,1.4,3.08c5.42,2.93,8.18-1.05,8.92-5.66C764.14,419.07,765.22,415.31,759.75,412.61Z",
  transform: "translate(-89 -52.5)",
  fill: "#ffe9b3"
});

var _ref80 = /*#__PURE__*/React.createElement("path", {
  d: "M759.75,412.61a8,8,0,0,0-5.22-.93,4.07,4.07,0,0,0-3.31,3.73l-2.88-.17a3.28,3.28,0,0,0-1,.05,1.66,1.66,0,0,0-1.13,1.91,1.64,1.64,0,0,0,1.87,1.19,9.71,9.71,0,0,0-3.69,2.6,5.18,5.18,0,0,0,1.4,7.14,5.6,5.6,0,0,0,7.26-1.47,2.62,2.62,0,0,0,1.4,3.08c5.42,2.93,8.18-1.05,8.92-5.66C764.14,419.07,765.22,415.31,759.75,412.61Z",
  transform: "translate(-89 -52.5)",
  opacity: 0.15
});

var _ref81 = /*#__PURE__*/React.createElement("path", {
  d: "M739.75,406.61a8,8,0,0,0-5.22-.93,4.07,4.07,0,0,0-3.31,3.73l-2.88-.17a3.28,3.28,0,0,0-1,.05,1.66,1.66,0,0,0-1.13,1.91,1.64,1.64,0,0,0,1.87,1.19,9.71,9.71,0,0,0-3.69,2.6,5.18,5.18,0,0,0,1.4,7.14,5.6,5.6,0,0,0,7.26-1.47,2.62,2.62,0,0,0,1.4,3.08c5.42,2.93,8.18-1.05,8.92-5.66C744.14,413.07,745.22,409.31,739.75,406.61Z",
  transform: "translate(-89 -52.5)",
  fill: "#ffe9b3"
});

var _ref82 = /*#__PURE__*/React.createElement("path", {
  d: "M739.75,406.61a8,8,0,0,0-5.22-.93,4.07,4.07,0,0,0-3.31,3.73l-2.88-.17a3.28,3.28,0,0,0-1,.05,1.66,1.66,0,0,0-1.13,1.91,1.64,1.64,0,0,0,1.87,1.19,9.71,9.71,0,0,0-3.69,2.6,5.18,5.18,0,0,0,1.4,7.14,5.6,5.6,0,0,0,7.26-1.47,2.62,2.62,0,0,0,1.4,3.08c5.42,2.93,8.18-1.05,8.92-5.66C744.14,413.07,745.22,409.31,739.75,406.61Z",
  transform: "translate(-89 -52.5)",
  opacity: 0.15
});

var _ref83 = /*#__PURE__*/React.createElement("path", {
  d: "M761.75,402.61a8,8,0,0,0-5.22-.93,4.07,4.07,0,0,0-3.31,3.73l-2.88-.17a3.28,3.28,0,0,0-1,.05,1.66,1.66,0,0,0-1.13,1.91,1.64,1.64,0,0,0,1.87,1.19,9.71,9.71,0,0,0-3.69,2.6,5.18,5.18,0,0,0,1.4,7.14,5.6,5.6,0,0,0,7.26-1.47,2.62,2.62,0,0,0,1.4,3.08c5.42,2.93,8.18-1.05,8.92-5.66C766.14,409.07,767.22,405.31,761.75,402.61Z",
  transform: "translate(-89 -52.5)",
  fill: "#ffe9b3"
});

var _ref84 = /*#__PURE__*/React.createElement("path", {
  d: "M761.75,402.61a8,8,0,0,0-5.22-.93,4.07,4.07,0,0,0-3.31,3.73l-2.88-.17a3.28,3.28,0,0,0-1,.05,1.66,1.66,0,0,0-1.13,1.91,1.64,1.64,0,0,0,1.87,1.19,9.71,9.71,0,0,0-3.69,2.6,5.18,5.18,0,0,0,1.4,7.14,5.6,5.6,0,0,0,7.26-1.47,2.62,2.62,0,0,0,1.4,3.08c5.42,2.93,8.18-1.05,8.92-5.66C766.14,409.07,767.22,405.31,761.75,402.61Z",
  transform: "translate(-89 -52.5)",
  opacity: 0.15
});

var _ref85 = /*#__PURE__*/React.createElement("path", {
  d: "M769.75,408.61a8,8,0,0,0-5.22-.93,4.07,4.07,0,0,0-3.31,3.73l-2.88-.17a3.28,3.28,0,0,0-1,.05,1.66,1.66,0,0,0-1.13,1.91,1.64,1.64,0,0,0,1.87,1.19,9.71,9.71,0,0,0-3.69,2.6,5.18,5.18,0,0,0,1.4,7.14,5.6,5.6,0,0,0,7.26-1.47,2.62,2.62,0,0,0,1.4,3.08c5.42,2.93,8.18-1.05,8.92-5.66C774.14,415.07,775.22,411.31,769.75,408.61Z",
  transform: "translate(-89 -52.5)",
  fill: "#ffe9b3"
});

var _ref86 = /*#__PURE__*/React.createElement("path", {
  d: "M769.75,408.61a8,8,0,0,0-5.22-.93,4.07,4.07,0,0,0-3.31,3.73l-2.88-.17a3.28,3.28,0,0,0-1,.05,1.66,1.66,0,0,0-1.13,1.91,1.64,1.64,0,0,0,1.87,1.19,9.71,9.71,0,0,0-3.69,2.6,5.18,5.18,0,0,0,1.4,7.14,5.6,5.6,0,0,0,7.26-1.47,2.62,2.62,0,0,0,1.4,3.08c5.42,2.93,8.18-1.05,8.92-5.66C774.14,415.07,775.22,411.31,769.75,408.61Z",
  transform: "translate(-89 -52.5)",
  opacity: 0.15
});

var _ref87 = /*#__PURE__*/React.createElement("path", {
  d: "M720.75,429.61a8,8,0,0,0-5.22-.93,4.07,4.07,0,0,0-3.31,3.73l-2.88-.17a3.28,3.28,0,0,0-1,.05,1.66,1.66,0,0,0-1.13,1.91,1.64,1.64,0,0,0,1.87,1.19,9.71,9.71,0,0,0-3.69,2.6,5.18,5.18,0,0,0,1.4,7.14,5.6,5.6,0,0,0,7.26-1.47,2.62,2.62,0,0,0,1.4,3.08c5.42,2.93,8.18-1.05,8.92-5.66C725.14,436.07,726.22,432.31,720.75,429.61Z",
  transform: "translate(-89 -52.5)",
  fill: "#ffe9b3"
});

var _ref88 = /*#__PURE__*/React.createElement("path", {
  d: "M720.75,429.61a8,8,0,0,0-5.22-.93,4.07,4.07,0,0,0-3.31,3.73l-2.88-.17a3.28,3.28,0,0,0-1,.05,1.66,1.66,0,0,0-1.13,1.91,1.64,1.64,0,0,0,1.87,1.19,9.71,9.71,0,0,0-3.69,2.6,5.18,5.18,0,0,0,1.4,7.14,5.6,5.6,0,0,0,7.26-1.47,2.62,2.62,0,0,0,1.4,3.08c5.42,2.93,8.18-1.05,8.92-5.66C725.14,436.07,726.22,432.31,720.75,429.61Z",
  transform: "translate(-89 -52.5)",
  opacity: 0.15
});

var _ref89 = /*#__PURE__*/React.createElement("path", {
  d: "M778.75,415.61a8,8,0,0,0-5.22-.93,4.07,4.07,0,0,0-3.31,3.73l-2.88-.17a3.28,3.28,0,0,0-1,.05,1.66,1.66,0,0,0-1.13,1.91,1.64,1.64,0,0,0,1.87,1.19,9.71,9.71,0,0,0-3.69,2.6,5.18,5.18,0,0,0,1.4,7.14,5.6,5.6,0,0,0,7.26-1.47,2.62,2.62,0,0,0,1.4,3.08c5.42,2.93,8.18-1.05,8.92-5.66C783.14,422.07,784.22,418.31,778.75,415.61Z",
  transform: "translate(-89 -52.5)",
  fill: "#ffe9b3"
});

var _ref90 = /*#__PURE__*/React.createElement("path", {
  d: "M778.75,415.61a8,8,0,0,0-5.22-.93,4.07,4.07,0,0,0-3.31,3.73l-2.88-.17a3.28,3.28,0,0,0-1,.05,1.66,1.66,0,0,0-1.13,1.91,1.64,1.64,0,0,0,1.87,1.19,9.71,9.71,0,0,0-3.69,2.6,5.18,5.18,0,0,0,1.4,7.14,5.6,5.6,0,0,0,7.26-1.47,2.62,2.62,0,0,0,1.4,3.08c5.42,2.93,8.18-1.05,8.92-5.66C783.14,422.07,784.22,418.31,778.75,415.61Z",
  transform: "translate(-89 -52.5)",
  opacity: 0.15
});

var _ref91 = /*#__PURE__*/React.createElement("path", {
  d: "M797.75,425.61a8,8,0,0,0-5.22-.93,4.07,4.07,0,0,0-3.31,3.73l-2.88-.17a3.28,3.28,0,0,0-1,.05,1.66,1.66,0,0,0-1.13,1.91,1.64,1.64,0,0,0,1.87,1.19,9.71,9.71,0,0,0-3.69,2.6,5.18,5.18,0,0,0,1.4,7.14,5.6,5.6,0,0,0,7.26-1.47,2.62,2.62,0,0,0,1.4,3.08c5.42,2.93,8.18-1.05,8.92-5.66C802.14,432.07,803.22,428.31,797.75,425.61Z",
  transform: "translate(-89 -52.5)",
  fill: "#ffe9b3"
});

var _ref92 = /*#__PURE__*/React.createElement("path", {
  d: "M797.75,425.61a8,8,0,0,0-5.22-.93,4.07,4.07,0,0,0-3.31,3.73l-2.88-.17a3.28,3.28,0,0,0-1,.05,1.66,1.66,0,0,0-1.13,1.91,1.64,1.64,0,0,0,1.87,1.19,9.71,9.71,0,0,0-3.69,2.6,5.18,5.18,0,0,0,1.4,7.14,5.6,5.6,0,0,0,7.26-1.47,2.62,2.62,0,0,0,1.4,3.08c5.42,2.93,8.18-1.05,8.92-5.66C802.14,432.07,803.22,428.31,797.75,425.61Z",
  transform: "translate(-89 -52.5)",
  opacity: 0.15
});

var _ref93 = /*#__PURE__*/React.createElement("path", {
  d: "M781.75,403.61a8,8,0,0,0-5.22-.93,4.07,4.07,0,0,0-3.31,3.73l-2.88-.17a3.28,3.28,0,0,0-1,.05,1.66,1.66,0,0,0-1.13,1.91,1.64,1.64,0,0,0,1.87,1.19,9.71,9.71,0,0,0-3.69,2.6,5.18,5.18,0,0,0,1.4,7.14,5.6,5.6,0,0,0,7.26-1.47,2.62,2.62,0,0,0,1.4,3.08c5.42,2.93,8.18-1.05,8.92-5.66C786.14,410.07,787.22,406.31,781.75,403.61Z",
  transform: "translate(-89 -52.5)",
  fill: "#ffe9b3"
});

var _ref94 = /*#__PURE__*/React.createElement("path", {
  d: "M781.75,403.61a8,8,0,0,0-5.22-.93,4.07,4.07,0,0,0-3.31,3.73l-2.88-.17a3.28,3.28,0,0,0-1,.05,1.66,1.66,0,0,0-1.13,1.91,1.64,1.64,0,0,0,1.87,1.19,9.71,9.71,0,0,0-3.69,2.6,5.18,5.18,0,0,0,1.4,7.14,5.6,5.6,0,0,0,7.26-1.47,2.62,2.62,0,0,0,1.4,3.08c5.42,2.93,8.18-1.05,8.92-5.66C786.14,410.07,787.22,406.31,781.75,403.61Z",
  transform: "translate(-89 -52.5)",
  opacity: 0.15
});

var _ref95 = /*#__PURE__*/React.createElement("path", {
  d: "M795.74,427.69a8,8,0,0,0,1-5.21,4.07,4.07,0,0,0-3.7-3.35l.21-2.88a3.3,3.3,0,0,0,0-1,1.59,1.59,0,0,0-3.1.71,9.73,9.73,0,0,0-2.56-3.72,5.18,5.18,0,0,0-7.16,1.32,5.6,5.6,0,0,0,1.4,7.28,2.63,2.63,0,0,0-3.1,1.37c-3,5.39,1,8.19,5.56,9C789.24,432,793,433.13,795.74,427.69Z",
  transform: "translate(-89 -52.5)",
  fill: "#ffe9b3"
});

var _ref96 = /*#__PURE__*/React.createElement("path", {
  d: "M795.74,411.69a8,8,0,0,0,1-5.21,4.07,4.07,0,0,0-3.7-3.35l.21-2.88a3.3,3.3,0,0,0,0-1,1.59,1.59,0,0,0-3.1.71,9.73,9.73,0,0,0-2.56-3.72,5.18,5.18,0,0,0-7.16,1.32,5.6,5.6,0,0,0,1.4,7.28,2.63,2.63,0,0,0-3.1,1.37c-3,5.39,1,8.19,5.56,9C789.24,416,793,417.13,795.74,411.69Z",
  transform: "translate(-89 -52.5)",
  fill: "#ffe9b3"
});

var _ref97 = /*#__PURE__*/React.createElement("path", {
  d: "M778.74,432.69a8,8,0,0,0,1-5.21,4.07,4.07,0,0,0-3.7-3.35l.21-2.88a3.3,3.3,0,0,0,0-1,1.59,1.59,0,0,0-3.1.71,9.73,9.73,0,0,0-2.56-3.72,5.18,5.18,0,0,0-7.16,1.32,5.6,5.6,0,0,0,1.4,7.28,2.63,2.63,0,0,0-3.1,1.37c-3,5.39,1,8.19,5.56,9C772.24,437,776,438.13,778.74,432.69Z",
  transform: "translate(-89 -52.5)",
  fill: "#ffe9b3"
});

var _ref98 = /*#__PURE__*/React.createElement("path", {
  d: "M797.74,450.69a8,8,0,0,0,1-5.21,4.07,4.07,0,0,0-3.7-3.35l.21-2.88a3.3,3.3,0,0,0,0-1,1.59,1.59,0,0,0-3.1.71,9.73,9.73,0,0,0-2.56-3.72,5.18,5.18,0,0,0-7.16,1.32,5.6,5.6,0,0,0,1.4,7.28,2.63,2.63,0,0,0-3.1,1.37c-3,5.39,1,8.19,5.56,9C791.24,455,795,456.13,797.74,450.69Z",
  transform: "translate(-89 -52.5)",
  fill: "#ffe9b3"
});

var _ref99 = /*#__PURE__*/React.createElement("path", {
  d: "M761.74,457.69a8,8,0,0,0,1-5.21,4.07,4.07,0,0,0-3.7-3.35l.21-2.88a3.3,3.3,0,0,0,0-1,1.59,1.59,0,0,0-3.1.71,9.73,9.73,0,0,0-2.56-3.72,5.18,5.18,0,0,0-7.16,1.32,5.6,5.6,0,0,0,1.4,7.28,2.63,2.63,0,0,0-3.1,1.37c-3,5.39,1,8.19,5.56,9C755.24,462,759,463.13,761.74,457.69Z",
  transform: "translate(-89 -52.5)",
  fill: "#ffe9b3"
});

var _ref100 = /*#__PURE__*/React.createElement("path", {
  d: "M753.74,416.69a8,8,0,0,0,1-5.21,4.07,4.07,0,0,0-3.7-3.35l.21-2.88a3.3,3.3,0,0,0,0-1,1.59,1.59,0,0,0-3.1.71,9.73,9.73,0,0,0-2.56-3.72,5.18,5.18,0,0,0-7.16,1.32,5.6,5.6,0,0,0,1.4,7.28,2.63,2.63,0,0,0-3.1,1.37c-3,5.39,1,8.19,5.56,9C747.24,421,751,422.13,753.74,416.69Z",
  transform: "translate(-89 -52.5)",
  fill: "#ffe9b3"
});

var _ref101 = /*#__PURE__*/React.createElement("path", {
  d: "M774.74,411.69a8,8,0,0,0,1-5.21,4.07,4.07,0,0,0-3.7-3.35l.21-2.88a3.3,3.3,0,0,0,0-1,1.59,1.59,0,0,0-3.1.71,9.73,9.73,0,0,0-2.56-3.72,5.18,5.18,0,0,0-7.16,1.32,5.6,5.6,0,0,0,1.4,7.28,2.63,2.63,0,0,0-3.1,1.37c-3,5.39,1,8.19,5.56,9C768.24,416,772,417.13,774.74,411.69Z",
  transform: "translate(-89 -52.5)",
  fill: "#ffe9b3"
});

var _ref102 = /*#__PURE__*/React.createElement("path", {
  d: "M732.74,430.69a8,8,0,0,0,1-5.21,4.07,4.07,0,0,0-3.7-3.35l.21-2.88a3.3,3.3,0,0,0,0-1,1.59,1.59,0,0,0-3.1.71,9.73,9.73,0,0,0-2.56-3.72,5.18,5.18,0,0,0-7.16,1.32,5.6,5.6,0,0,0,1.4,7.28,2.63,2.63,0,0,0-3.1,1.37c-3,5.39,1,8.19,5.56,9C726.24,435,730,436.13,732.74,430.69Z",
  transform: "translate(-89 -52.5)",
  fill: "#ffe9b3"
});

var _ref103 = /*#__PURE__*/React.createElement("path", {
  d: "M716.81,476.56c5.2-.42,10.33-1.75,15.55-1.68,6.83.09,13.4,2.56,19.62,5.38a15.47,15.47,0,0,1,4.94,3.08,10.43,10.43,0,0,1,2.38,8.72,22.58,22.58,0,0,1-3.58,8.58c-1.82,2.89-4.07,5.74-7.24,7a17.38,17.38,0,0,1-5.51.95c-7.83.43-15.81,0-23.24-2.51-3.81-1.3-7.42-3.12-11.15-4.66-11.89-4.92-24.75-6.86-37.38-9.34a3.84,3.84,0,0,1-1.78-.69c-2.63-2.27,3.08-10.45,4.42-12.74,2.26-3.89,4.31-4.31,8.89-4.42C694.17,473.94,705.34,477.27,716.81,476.56Z",
  transform: "translate(-89 -52.5)",
  fill: "#a0616a"
});

var _ref104 = /*#__PURE__*/React.createElement("path", {
  d: "M805.78,504.23c-3.62-1.78-6.87-4.24-10.46-6.09a35.26,35.26,0,0,0-14.57-3.87c-3.29-.15-6.87.29-9.26,2.56-3.41,3.24-3,8.75-1.88,13.32,1.7,6.85,5.12,14.1,11.69,16.69a26.59,26.59,0,0,0,8,1.37c12.17.84,24.84,1.6,36.12-3a3.66,3.66,0,0,0,2-1.53c.49-1,0-2.2-.5-3.21-1.8-3.62-4.65-11.21-8.13-13.47C815.55,504.83,809.82,506.21,805.78,504.23Z",
  transform: "translate(-89 -52.5)",
  fill: "#a0616a"
});

var _ref105 = /*#__PURE__*/React.createElement("path", {
  d: "M834.38,449.77a170.08,170.08,0,0,1,16.34,33.63,27.8,27.8,0,0,1,2,9.09c0,3.47-1.21,6.83-2.48,10.11a271,271,0,0,1-14.06,30.64c-1.6,3-3.43,6.13-6.6,7.78-3.33,1.74-7.43,1.47-11.24,1A217.14,217.14,0,0,1,790,537c5.87.19,11.17-4.21,13.88-9s3.31-10.27,3.76-15.62a23.71,23.71,0,0,0-.36-8.65,9.4,9.4,0,0,0-5.82-6.45c-.27-2.61,2.22-4.8,4.79-6s5.49-1.87,7.58-3.67c3.08-2.64,3.52-7.05,2.51-10.79s-3.21-7.12-4.77-10.71c-2.19-5,9.11-10.26,9.56-15.66.1-1.22-.76,1,0,0s5.48,2.47,6.55,2C834.71,449.41,830.49,443.59,834.38,449.77Z",
  transform: "translate(-89 -52.5)",
  opacity: 0.1
});

var _ref106 = /*#__PURE__*/React.createElement("path", {
  d: "M836.56,449.77a170.68,170.68,0,0,1,16.35,33.63,27.53,27.53,0,0,1,2,9.09c0,3.47-1.21,6.83-2.47,10.11a272.79,272.79,0,0,1-14.06,30.64c-1.6,3-3.43,6.13-6.6,7.78-3.33,1.74-7.44,1.47-11.24,1A216.55,216.55,0,0,1,792.19,537c5.86.19,11.17-4.21,13.87-9s3.32-10.27,3.77-15.62a23.93,23.93,0,0,0-.36-8.65,9.44,9.44,0,0,0-5.82-6.45c-.28-2.61,2.22-4.8,4.79-6s5.49-1.87,7.58-3.67c3.07-2.64,3.51-7.05,2.5-10.79s-3.21-7.12-4.77-10.71a33.21,33.21,0,0,1-2.66-15.92,6.72,6.72,0,0,1,1.06-3.51,6.86,6.86,0,0,1,2.79-2C822,441.68,832.67,443.59,836.56,449.77Z",
  transform: "translate(-89 -52.5)",
  fill: "#f98a8d"
});

var _ref107 = /*#__PURE__*/React.createElement("path", {
  d: "M622.8,439.85c-6.49,6-13.19,12.34-16.35,20.61-1.72,4.51-2.29,9.37-2.85,14.17-.94,8.18-1.79,16.94,2,24.24,4.2,8,13,12.29,21.26,15.92a59,59,0,0,0,8.85,3.32,62.17,62.17,0,0,0,12.1,1.48l41.69,2.32c-5.44-5.48-8.92-14.06-8.18-21.75.67-6.87,4-13.17,7.35-19.18,1.74-3.1,3.71-6.36,6.92-7.89a134.53,134.53,0,0,0-41.4-2.6c-.93.08-2,.11-2.61-.63a2.5,2.5,0,0,1-.4-1.57c0-6.21,4.64-11.37,6.56-17.27,3.07-9.46-7.38-4.27-16.78-7.52S624.72,430.09,622.8,439.85Z",
  transform: "translate(-89 -52.5)",
  opacity: 0.1
});

var _ref108 = /*#__PURE__*/React.createElement("path", {
  d: "M619.8,439.85c-6.49,6-13.19,12.34-16.35,20.61-1.72,4.51-2.29,9.37-2.85,14.17-.94,8.18-1.79,16.94,2,24.24,4.2,8,13,12.29,21.26,15.92a59,59,0,0,0,8.85,3.32,62.17,62.17,0,0,0,12.1,1.48l41.69,2.32c-5.44-5.48-8.92-14.06-8.18-21.75.67-6.87,4-13.17,7.35-19.18,1.74-3.1,3.71-6.36,6.92-7.89a134.53,134.53,0,0,0-41.4-2.6c-.93.08-2,.11-2.61-.63a2.5,2.5,0,0,1-.4-1.57c0-6.21,4.64-11.37,6.56-17.27,3.07-9.46-2.27-21-11.68-24.27S621.72,430.09,619.8,439.85Z",
  transform: "translate(-89 -52.5)",
  fill: "#f98a8d"
});

var _ref109 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 635.5,
  cy: 259,
  rx: 50.5,
  ry: 21,
  fill: "#2f2e41"
});

var _ref110 = /*#__PURE__*/React.createElement("path", {
  d: "M723.5,323.5c-24.17,0-44.37-7.07-49.33-16.5a9.61,9.61,0,0,0-1.17,4.5c0,11.6,22.61,21,50.5,21s50.5-9.4,50.5-21a9.61,9.61,0,0,0-1.17-4.5C767.87,316.43,747.67,323.5,723.5,323.5Z",
  transform: "translate(-89 -52.5)",
  opacity: 0.1
});

var _ref111 = /*#__PURE__*/React.createElement("path", {
  d: "M791.75,325.61a8,8,0,0,0-5.22-.93,4.07,4.07,0,0,0-3.31,3.73l-2.88-.17a3.28,3.28,0,0,0-1,.05,1.66,1.66,0,0,0-1.13,1.91,1.64,1.64,0,0,0,1.87,1.19,9.71,9.71,0,0,0-3.69,2.6,5.18,5.18,0,0,0,1.4,7.14,5.6,5.6,0,0,0,7.26-1.47,2.62,2.62,0,0,0,1.4,3.08c5.42,2.93,8.18-1.05,8.92-5.66C796.14,332.07,797.22,328.31,791.75,325.61Z",
  transform: "translate(-89 -52.5)",
  fill: "#ffe9b3"
});

var _ref112 = /*#__PURE__*/React.createElement("path", {
  d: "M791.75,325.61a8,8,0,0,0-5.22-.93,4.07,4.07,0,0,0-3.31,3.73l-2.88-.17a3.28,3.28,0,0,0-1,.05,1.66,1.66,0,0,0-1.13,1.91,1.64,1.64,0,0,0,1.87,1.19,9.71,9.71,0,0,0-3.69,2.6,5.18,5.18,0,0,0,1.4,7.14,5.6,5.6,0,0,0,7.26-1.47,2.62,2.62,0,0,0,1.4,3.08c5.42,2.93,8.18-1.05,8.92-5.66C796.14,332.07,797.22,328.31,791.75,325.61Z",
  transform: "translate(-89 -52.5)",
  opacity: 0.15
});

var _ref113 = /*#__PURE__*/React.createElement("path", {
  d: "M839.75,401.61a8,8,0,0,0-5.22-.93,4.07,4.07,0,0,0-3.31,3.73l-2.88-.17a3.28,3.28,0,0,0-1,.05,1.66,1.66,0,0,0-1.13,1.91,1.64,1.64,0,0,0,1.87,1.19,9.71,9.71,0,0,0-3.69,2.6,5.18,5.18,0,0,0,1.4,7.14,5.6,5.6,0,0,0,7.26-1.47,2.62,2.62,0,0,0,1.4,3.08c5.42,2.93,8.18-1.05,8.92-5.66C844.14,408.07,845.22,404.31,839.75,401.61Z",
  transform: "translate(-89 -52.5)",
  fill: "#ffe9b3"
});

var _ref114 = /*#__PURE__*/React.createElement("path", {
  d: "M839.75,401.61a8,8,0,0,0-5.22-.93,4.07,4.07,0,0,0-3.31,3.73l-2.88-.17a3.28,3.28,0,0,0-1,.05,1.66,1.66,0,0,0-1.13,1.91,1.64,1.64,0,0,0,1.87,1.19,9.71,9.71,0,0,0-3.69,2.6,5.18,5.18,0,0,0,1.4,7.14,5.6,5.6,0,0,0,7.26-1.47,2.62,2.62,0,0,0,1.4,3.08c5.42,2.93,8.18-1.05,8.92-5.66C844.14,408.07,845.22,404.31,839.75,401.61Z",
  transform: "translate(-89 -52.5)",
  opacity: 0.15
});

var _ref115 = /*#__PURE__*/React.createElement("path", {
  d: "M895.75,482.61a8,8,0,0,0-5.22-.93,4.07,4.07,0,0,0-3.31,3.73l-2.88-.17a3.28,3.28,0,0,0-1,.05,1.66,1.66,0,0,0-1.13,1.91,1.64,1.64,0,0,0,1.87,1.19,9.71,9.71,0,0,0-3.69,2.6,5.18,5.18,0,0,0,1.4,7.14,5.6,5.6,0,0,0,7.26-1.47,2.62,2.62,0,0,0,1.4,3.08c5.42,2.93,8.18-1.05,8.92-5.66C900.14,489.07,901.22,485.31,895.75,482.61Z",
  transform: "translate(-89 -52.5)",
  fill: "#ffe9b3"
});

var _ref116 = /*#__PURE__*/React.createElement("path", {
  d: "M895.75,482.61a8,8,0,0,0-5.22-.93,4.07,4.07,0,0,0-3.31,3.73l-2.88-.17a3.28,3.28,0,0,0-1,.05,1.66,1.66,0,0,0-1.13,1.91,1.64,1.64,0,0,0,1.87,1.19,9.71,9.71,0,0,0-3.69,2.6,5.18,5.18,0,0,0,1.4,7.14,5.6,5.6,0,0,0,7.26-1.47,2.62,2.62,0,0,0,1.4,3.08c5.42,2.93,8.18-1.05,8.92-5.66C900.14,489.07,901.22,485.31,895.75,482.61Z",
  transform: "translate(-89 -52.5)",
  opacity: 0.15
});

var _ref117 = /*#__PURE__*/React.createElement("path", {
  d: "M809.74,303.69a8,8,0,0,0,1-5.21,4.07,4.07,0,0,0-3.7-3.35l.21-2.88a3.3,3.3,0,0,0,0-1,1.59,1.59,0,0,0-3.1.71,9.73,9.73,0,0,0-2.56-3.72,5.18,5.18,0,0,0-7.16,1.32,5.6,5.6,0,0,0,1.4,7.28,2.63,2.63,0,0,0-3.1,1.37c-3,5.39,1,8.19,5.56,9C803.24,308,807,309.13,809.74,303.69Z",
  transform: "translate(-89 -52.5)",
  fill: "#ffe9b3"
});

var _ref118 = /*#__PURE__*/React.createElement("path", {
  d: "M803.74,268.69a8,8,0,0,0,1-5.21,4.07,4.07,0,0,0-3.7-3.35l.21-2.88a3.3,3.3,0,0,0,0-1,1.59,1.59,0,0,0-3.1.71,9.73,9.73,0,0,0-2.56-3.72,5.18,5.18,0,0,0-7.16,1.32,5.6,5.6,0,0,0,1.4,7.28,2.63,2.63,0,0,0-3.1,1.37c-3,5.39,1,8.19,5.56,9C797.24,273,801,274.13,803.74,268.69Z",
  transform: "translate(-89 -52.5)",
  fill: "#ffe9b3"
});

var _ref119 = /*#__PURE__*/React.createElement("path", {
  d: "M653.75,556.61a8,8,0,0,0-5.22-.93,4.07,4.07,0,0,0-3.31,3.73l-2.88-.17a3.28,3.28,0,0,0-1,0,1.66,1.66,0,0,0-1.13,1.91,1.64,1.64,0,0,0,1.87,1.19,9.71,9.71,0,0,0-3.69,2.6,5.18,5.18,0,0,0,1.4,7.14,5.6,5.6,0,0,0,7.26-1.47,2.62,2.62,0,0,0,1.4,3.08c5.42,2.93,8.18-1,8.92-5.66C658.14,563.07,659.22,559.31,653.75,556.61Z",
  transform: "translate(-89 -52.5)",
  fill: "#ffe9b3"
});

var _ref120 = /*#__PURE__*/React.createElement("path", {
  d: "M653.75,556.61a8,8,0,0,0-5.22-.93,4.07,4.07,0,0,0-3.31,3.73l-2.88-.17a3.28,3.28,0,0,0-1,0,1.66,1.66,0,0,0-1.13,1.91,1.64,1.64,0,0,0,1.87,1.19,9.71,9.71,0,0,0-3.69,2.6,5.18,5.18,0,0,0,1.4,7.14,5.6,5.6,0,0,0,7.26-1.47,2.62,2.62,0,0,0,1.4,3.08c5.42,2.93,8.18-1,8.92-5.66C658.14,563.07,659.22,559.31,653.75,556.61Z",
  transform: "translate(-89 -52.5)",
  opacity: 0.15
});

var _ref121 = /*#__PURE__*/React.createElement("path", {
  d: "M617.74,554.69a8,8,0,0,0,1-5.21,4.07,4.07,0,0,0-3.7-3.35l.21-2.88a3.3,3.3,0,0,0,0-1,1.59,1.59,0,0,0-3.1.71,9.73,9.73,0,0,0-2.56-3.72,5.18,5.18,0,0,0-7.16,1.32,5.6,5.6,0,0,0,1.4,7.28,2.63,2.63,0,0,0-3.1,1.37c-3,5.39,1,8.19,5.56,9C611.24,559,615,560.13,617.74,554.69Z",
  transform: "translate(-89 -52.5)",
  fill: "#ffe9b3"
});

var _ref122 = /*#__PURE__*/React.createElement("path", {
  d: "M665.74,499.69a8,8,0,0,0,1-5.21,4.07,4.07,0,0,0-3.7-3.35l.21-2.88a3.3,3.3,0,0,0,0-1,1.59,1.59,0,0,0-3.1.71,9.73,9.73,0,0,0-2.56-3.72,5.18,5.18,0,0,0-7.16,1.32,5.6,5.6,0,0,0,1.4,7.28,2.63,2.63,0,0,0-3.1,1.37c-3,5.39,1,8.19,5.56,9C659.24,504,663,505.13,665.74,499.69Z",
  transform: "translate(-89 -52.5)",
  fill: "#ffe9b3"
});

var _ref123 = /*#__PURE__*/React.createElement("path", {
  d: "M588.91,517.85c-9.74-2.49-19.88-5-29.72-3-4.38.89-8.52,2.65-12.78,4a73.11,73.11,0,0,1-62.74-9.37c-10.2-7.05-20.8-17.33-32.88-14.54-3.25.76-6.26,2.46-9.58,2.83-6.23.71-12-3.33-18.18-4.28-10.64-1.63-20.31,5.83-28.49,12.83l-43.13,36.91c-3.27,2.8-6.87,6.5-6,10.7,1.33,6.17,10.78,7,13.21,12.85,1.76,4.19-1.15,9.07-5,11.46s-8.51,3-12.83,4.45a39.9,39.9,0,0,0-26.28,29.2c-.76,3.58-1,7.3-2.41,10.68-1.52,3.68-4.27,6.7-6.3,10.12-8.88,14.9-3.05,34.67-9.79,50.65-3.57,8.48-10.72,16.68-8.46,25.59,2.06,8.08,10.93,12.21,19,14.35.95,5.5-1,9.38-5,13.33,33.55,13.79,69.56,27.87,105.15,20.82,12.21-2.41,24.1-7.3,36.54-7.1,8.83.14,17.56,2.86,26.37,2.24,18.59-1.31,35.66-17.2,53.67-12.43-5.43.37-7.44,8.31-4.24,12.72s9.09,5.82,14.51,6.34,11.16.56,15.86,3.32c-3.56,7.41-16.31,10-15.08,18.15.45,2.94,2.83,5.17,5.19,7,24.25,18.57,57.65,16.79,88,20,22.38,2.34,44.32,7.81,66.63,10.73,35.64,4.65,71.77,2.75,107.65.83,6.51-.35,13.81-1.07,18-6.07,5.56-6.66,2.47-16.53,1.77-25.17-2.72-33.81,34.26-57.08,44.62-89.38,4-12.61,3.83-26.16,3.11-39.39-1.61-29.84-6.28-61.32-25.3-84.36-15.66-19-39.07-29.7-62.38-37.54-14.84-5-30.39-9.11-46-7.64-26.2,2.47-52.67,20.36-76.86,10-6.4-2.74-11.85-7.27-17.93-10.65C624.85,520,606.72,522.4,588.91,517.85Z",
  transform: "translate(-89 -52.5)",
  fill: "#e83f5b"
});

var _ref124 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  d: "M724.21,792.36C701.9,789.44,680,784,657.58,781.63c-30.38-3.18-63.78-1.4-88-20-2.36-1.81-4.74-4-5.19-7-1.23-8.13,11.52-10.74,15.08-18.15-4.7-2.76-10.43-2.79-15.86-3.32s-11.31-1.93-14.51-6.34-1.19-12.35,4.24-12.72c-18-4.77-35.08,11.12-53.67,12.43-8.81.62-17.54-2.1-26.37-2.24-12.44-.2-24.33,4.69-36.54,7.1-35.59,7-71.59-7-105.15-20.82,3.95-4,5.92-7.83,5-13.33-8.05-2.14-16.92-6.27-19-14.35-2.26-8.91,4.89-17.11,8.46-25.59,6.74-16,.91-35.75,9.79-50.65,2-3.42,4.78-6.44,6.3-10.12,1.39-3.38,1.65-7.1,2.41-10.68a35.2,35.2,0,0,1,1.3-4.62c-1.68.46-3.38.88-5,1.42a39.9,39.9,0,0,0-26.28,29.2c-.76,3.58-1,7.3-2.41,10.68-1.52,3.68-4.27,6.7-6.3,10.12-8.88,14.9-3.05,34.67-9.79,50.65-3.57,8.48-10.72,16.68-8.46,25.59,2.06,8.08,10.93,12.21,19,14.35.95,5.5-1,9.38-5,13.33,33.56,13.79,69.56,27.87,105.15,20.82,12.21-2.41,24.1-7.3,36.54-7.1,8.83.14,17.56,2.86,26.37,2.24,18.59-1.31,35.66-17.2,53.67-12.43-5.43.37-7.44,8.31-4.24,12.72s9.09,5.82,14.51,6.34,11.16.56,15.86,3.32c-3.56,7.41-16.31,10-15.08,18.15.45,2.94,2.83,5.17,5.19,7,24.25,18.57,57.65,16.79,88,20,22.38,2.34,44.32,7.81,66.63,10.73,35.64,4.65,71.77,2.75,107.65.83,6.51-.35,13.81-1.07,18-6.07,4.35-5.22,3.4-12.4,2.45-19.43C789.57,795.39,756.68,796.6,724.21,792.36Z",
  transform: "translate(-89 -52.5)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M357.18,564.54a38.57,38.57,0,0,1,13.63-7.84c4.32-1.4,9-2.07,12.83-4.45s6.77-7.27,5-11.46c-2.43-5.81-11.88-6.68-13.21-12.85-.61-2.84.84-5.45,2.86-7.71l-26.89,23c-3.27,2.8-6.87,6.5-6,10.7C346.57,559.21,353.63,560.62,357.18,564.54Z",
  transform: "translate(-89 -52.5)"
}));

var _ref125 = /*#__PURE__*/React.createElement("path", {
  d: "M447.74,544.69a8,8,0,0,0,1-5.21,4.07,4.07,0,0,0-3.7-3.35l.21-2.88a3.3,3.3,0,0,0-.05-1,1.59,1.59,0,0,0-3.1.71,9.73,9.73,0,0,0-2.56-3.72,5.18,5.18,0,0,0-7.16,1.32,5.6,5.6,0,0,0,1.4,7.28,2.63,2.63,0,0,0-3.1,1.37c-3,5.39,1,8.19,5.56,9C441.24,549,445,550.13,447.74,544.69Z",
  transform: "translate(-89 -52.5)",
  fill: "#ffe9b3"
});

var _ref126 = /*#__PURE__*/React.createElement("path", {
  d: "M593.74,738.69a8,8,0,0,0,1-5.21,4.07,4.07,0,0,0-3.7-3.35l.21-2.88a3.3,3.3,0,0,0,0-1,1.59,1.59,0,0,0-3.1.71,9.73,9.73,0,0,0-2.56-3.72,5.18,5.18,0,0,0-7.16,1.32,5.6,5.6,0,0,0,1.4,7.28,2.63,2.63,0,0,0-3.1,1.37c-3,5.39,1,8.19,5.56,9C587.24,743,591,744.13,593.74,738.69Z",
  transform: "translate(-89 -52.5)",
  fill: "#ffe9b3"
});

var _ref127 = /*#__PURE__*/React.createElement("path", {
  d: "M693.74,547.69a8,8,0,0,0,1-5.21,4.07,4.07,0,0,0-3.7-3.35l.21-2.88a3.3,3.3,0,0,0,0-1,1.59,1.59,0,0,0-3.1.71,9.73,9.73,0,0,0-2.56-3.72,5.18,5.18,0,0,0-7.16,1.32,5.6,5.6,0,0,0,1.4,7.28,2.63,2.63,0,0,0-3.1,1.37c-3,5.39,1,8.19,5.56,9C687.24,552,691,553.13,693.74,547.69Z",
  transform: "translate(-89 -52.5)",
  fill: "#ffe9b3"
});

var _ref128 = /*#__PURE__*/React.createElement("path", {
  d: "M712.55,545.49a8,8,0,0,0,3.86-3.63,4.06,4.06,0,0,0-1-4.88l1.85-2.22a3.26,3.26,0,0,0,.58-.86,1.59,1.59,0,0,0-2.93-1.25,9.71,9.71,0,0,0,.11-4.51,5.18,5.18,0,0,0-6.58-3.13,5.59,5.59,0,0,0-3.13,6.71A2.64,2.64,0,0,0,702,531c-5.58,2.61-4,7.19-.76,10.53C704.74,545.18,707.12,548.29,712.55,545.49Z",
  transform: "translate(-89 -52.5)",
  fill: "#ffe9b3"
});

var _ref129 = /*#__PURE__*/React.createElement("path", {
  d: "M495.75,550.61a8,8,0,0,0-5.22-.93,4.07,4.07,0,0,0-3.31,3.73l-2.88-.17a3.28,3.28,0,0,0-1,0,1.66,1.66,0,0,0-1.13,1.91,1.64,1.64,0,0,0,1.87,1.19,9.71,9.71,0,0,0-3.69,2.6,5.18,5.18,0,0,0,1.4,7.14,5.6,5.6,0,0,0,7.26-1.47,2.62,2.62,0,0,0,1.4,3.08c5.42,2.93,8.18-1,8.92-5.66C500.14,557.07,501.22,553.31,495.75,550.61Z",
  transform: "translate(-89 -52.5)",
  fill: "#ffe9b3"
});

var _ref130 = /*#__PURE__*/React.createElement("path", {
  d: "M495.75,550.61a8,8,0,0,0-5.22-.93,4.07,4.07,0,0,0-3.31,3.73l-2.88-.17a3.28,3.28,0,0,0-1,0,1.66,1.66,0,0,0-1.13,1.91,1.64,1.64,0,0,0,1.87,1.19,9.71,9.71,0,0,0-3.69,2.6,5.18,5.18,0,0,0,1.4,7.14,5.6,5.6,0,0,0,7.26-1.47,2.62,2.62,0,0,0,1.4,3.08c5.42,2.93,8.18-1,8.92-5.66C500.14,557.07,501.22,553.31,495.75,550.61Z",
  transform: "translate(-89 -52.5)",
  opacity: 0.15
});

var _ref131 = /*#__PURE__*/React.createElement("path", {
  d: "M584.79,625a8.11,8.11,0,0,0-.86-5.23,4.06,4.06,0,0,0-4.63-1.87l-.8-2.78a3.37,3.37,0,0,0-.4-1,1.59,1.59,0,0,0-2.67,1.74,9.66,9.66,0,0,0-3.68-2.62,5.19,5.19,0,0,0-6.27,3.71,5.6,5.6,0,0,0,3.82,6.35,2.63,2.63,0,0,0-2.44,2.35c-1,6.09,3.72,7.36,8.31,6.52C580.17,631.26,584.07,631,584.79,625Z",
  transform: "translate(-89 -52.5)",
  fill: "#ffe9b3"
});

var _ref132 = /*#__PURE__*/React.createElement("path", {
  d: "M584.79,625a8.11,8.11,0,0,0-.86-5.23,4.06,4.06,0,0,0-4.63-1.87l-.8-2.78a3.37,3.37,0,0,0-.4-1,1.59,1.59,0,0,0-2.67,1.74,9.66,9.66,0,0,0-3.68-2.62,5.19,5.19,0,0,0-6.27,3.71,5.6,5.6,0,0,0,3.82,6.35,2.63,2.63,0,0,0-2.44,2.35c-1,6.09,3.72,7.36,8.31,6.52C580.17,631.26,584.07,631,584.79,625Z",
  transform: "translate(-89 -52.5)",
  opacity: 0.15
});

var _ref133 = /*#__PURE__*/React.createElement("path", {
  d: "M704.79,534a8.11,8.11,0,0,0-.86-5.23,4.06,4.06,0,0,0-4.63-1.87l-.8-2.78a3.37,3.37,0,0,0-.4-1,1.59,1.59,0,0,0-2.67,1.74,9.66,9.66,0,0,0-3.68-2.62,5.19,5.19,0,0,0-6.27,3.71,5.6,5.6,0,0,0,3.82,6.35,2.63,2.63,0,0,0-2.44,2.35c-1,6.09,3.72,7.36,8.31,6.52C700.17,540.26,704.07,540,704.79,534Z",
  transform: "translate(-89 -52.5)",
  fill: "#ffe9b3"
});

var _ref134 = /*#__PURE__*/React.createElement("path", {
  d: "M704.79,534a8.11,8.11,0,0,0-.86-5.23,4.06,4.06,0,0,0-4.63-1.87l-.8-2.78a3.37,3.37,0,0,0-.4-1,1.59,1.59,0,0,0-2.67,1.74,9.66,9.66,0,0,0-3.68-2.62,5.19,5.19,0,0,0-6.27,3.71,5.6,5.6,0,0,0,3.82,6.35,2.63,2.63,0,0,0-2.44,2.35c-1,6.09,3.72,7.36,8.31,6.52C700.17,540.26,704.07,540,704.79,534Z",
  transform: "translate(-89 -52.5)",
  opacity: 0.15
});

var SvgEmpty = function SvgEmpty(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "be525a17-233a-4c46-b302-bf89f84956bb",
    "data-name": "Layer 1",
    width: 1022,
    height: 795,
    viewBox: "0 0 1022 795",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124, _ref125, _ref126, _ref127, _ref128, _ref129, _ref130, _ref131, _ref132, _ref133, _ref134);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmpty, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/empty.e99712c5.svg";
export { ForwardRef as ReactComponent };